import React from 'react';

function SecondaryCTA() {
  return (
    <section id="secondary-cta-section" className="section-padding">
      <div className="container text-center">
        <a href="#services-section" className="btn btn-secondary mr-2">Explore Agentic Capabilities</a>
        <a href="#expertise-section" className="btn btn-secondary mr-2">Review Dual-Cloud Stack</a>
        <a href="#contact-form" className="btn btn-secondary">Request Autonomous Agent Demo</a>
      </div>
    </section>
  );
}

export default SecondaryCTA;
